import { Breadcrumb as Breadcrumb$1, StyledBreadcrumbItem } from './Breadcrumb.js';
export { breadcrumbDividerStyles, breadcrumbStyles } from './Breadcrumb.js';

const Breadcrumb = Object.assign(Breadcrumb$1, {
    Item: StyledBreadcrumbItem,
});

export { Breadcrumb };
